import { render, staticRenderFns } from "./huodong.vue?vue&type=template&id=20cb2cf8&scoped=true&"
import script from "./huodong.vue?vue&type=script&lang=js&"
export * from "./huodong.vue?vue&type=script&lang=js&"
import style0 from "./huodong.vue?vue&type=style&index=0&id=20cb2cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cb2cf8",
  null
  
)

export default component.exports